import React, { useState, useEffect } from "react";
import { Button, Form, Col, Row, Modal } from "react-bootstrap";
import PdfDisplay from "./PdfDisplay";
import { CircularProgress } from "@material-ui/core";
import axios from "axios";
import ApiService from "../../../ApiService.js";

const PatientIdentityDocsModal = ({
  show,
  handleClose,
  rejectDoc,
  acceptDoc,
  govermentIssuedId,
  selfie,
  isSelfCheckInIdentityVerified,
  bookingId,
  openDocVerification,
  refreshBookingDetails,
  setShow
}) => {
  const govermentIssuedIdLink = govermentIssuedId?.substring(0, govermentIssuedId?.indexOf("?"));
  const govermentIssuedIdFileFormat = govermentIssuedIdLink?.substring(govermentIssuedIdLink?.lastIndexOf(".") + 1);

  const selfieURLLink = selfie?.substring(0, selfie?.indexOf("?"));
  const selfieFileFormat = selfieURLLink?.substring(selfieURLLink?.lastIndexOf(".") + 1);

  useEffect(() => {
    openDocVerification();
  }, []);

  const handleFileChange = e => {
    console.log("handleFileChange", e.target.files[0]);
    setSelectedFile(e.target.files[0]);
  };
  const handlePhotoChange = e => {
    console.log("handleFileChange", e.target.files[0]);
    setSelectedPhoto(e.target.files[0]);
  };

  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [isUploadInprogress, setIsUploadInprogress] = useState(false);
  const [isUploadPhotoInprogress, setIsUploadPhotoInprogress] = useState(false);

  const handleUpload = async type => {
    const isDocument = type === "IDENTITY_PASSPORT";
    if (isDocument && !selectedFile) {
      alert("Please select a file to upload");
      return;
    }
    if (!isDocument && !selectedPhoto) {
      alert("Please select a photo to upload");
      return;
    }

    isDocument ? setIsUploadInprogress(true) : setIsUploadPhotoInprogress(true);
    try {
      const response = await ApiService.uploadDocument(isDocument ? selectedFile : selectedPhoto, bookingId, type);
      console.log("Document uploaded successfully:", response.data);
    } catch (error) {
      console.error("Error uploading document:", error);
    } finally {
      isDocument ? setIsUploadInprogress(false) : setIsUploadPhotoInprogress(false);
      handleClose();
      window.location.reload().then(() => {
        setShow()
      })
    }
  };

  return (
    <Modal size="xl" show={show} onHide={() => handleClose()} backdrop={"static"}>
      <Modal.Body>
        <Row>
          <Col>
            <h6 style={{ fontWeight: "600" }}>Government issued ID</h6>
            {govermentIssuedId && govermentIssuedIdFileFormat === "pdf" ? (
              <PdfDisplay fileUrl={govermentIssuedId} />
            ) : (
              <img
                alt="doc"
                style={{
                  width: "100%",
                  height: 350,
                  objectFit: "contain",
                  background: "#D9D9D9",
                  border: "1px solid",
                  borderColor: "gray",
                  padding: 10,
                  marginTop: 20
                }}
                src={govermentIssuedId}
              />
            )}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: 10
              }}
            >
              <label className="file-picker-label">
                <input type="file" onChange={handleFileChange} className="file-picker-input" accept=".pdf,.jpg,.jpeg,.png" />
                <span className="file-picker-button">Choose Identity Document</span>
                <br />
                {selectedFile ? <span className="file-name">{selectedFile.name}</span> : <span className="file-name">Select document to upload</span>}
              </label>

              <Button
                id="msg_reply"
                class="replyButton sendButton text-right"
                onClick={() => handleUpload("IDENTITY_PASSPORT")}
                disabled={isUploadInprogress}
              >
                {isUploadInprogress ? <CircularProgress size={15} color="inherit" /> : "Replace Document"}
              </Button>
            </div>
          </Col>
          <Col>
            <h6 style={{ fontWeight: "600" }}>Patient photo</h6>
            {selfie && selfieFileFormat === "pdf" ? (
              <PdfDisplay fileUrl={govermentIssuedId} />
            ) : (
              <img
                alt="doc2"
                style={{
                  width: "100%",
                  height: 350,
                  objectFit: "contain",
                  background: "#D9D9D9",
                  border: "1px solid",
                  borderColor: "gray",
                  padding: 10,
                  marginTop: 20
                }}
                src={selfie}
              />
            )}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: 10
              }}
            >
              <label className="file-picker-label">
                <input type="file" onChange={handlePhotoChange} className="file-picker-input" accept=".pdf,.jpg,.jpeg,.png" />
                <span className="file-picker-button">Choose Selfie Photo</span><br />
                {selectedPhoto ? <span className="file-name">{selectedPhoto.name}</span> : <span className="file-name">Select photo to upload</span>}
              </label>

              <Button
                id="msg_reply"
                class="replyButton sendButton text-right"
                onClick={() => handleUpload("SELFIE")}
                disabled={isUploadPhotoInprogress}
              >
                {isUploadPhotoInprogress ? <CircularProgress size={15} color="inherit" /> : "Replace Selfie"}
              </Button>
            </div>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Row style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
          <Button
            variant="dark"
            onClick={handleClose}
            style={{ paddingLeft: 40, paddingRight: 40 }}
            disabled={isUploadInprogress || isUploadPhotoInprogress}
          >
            Close
          </Button>
        </Row>
      </Modal.Footer>
    </Modal>
  );
};

export default PatientIdentityDocsModal;
